export default "__VITE_ASSET__CybP3$EZ__"